<template>
  <div>
    <h1>Importar CSV</h1>
    <input type="file" @change="onFileChange" accept=".csv, text/csv" />
    <button @click="uploadFile">Fazer Upload</button>
    <p v-if="message">{{ message }}</p>
  </div>
</template>

<script>
import axios from 'axios';

// const url = "http://" + window.location.hostname + ":8000/api";
const url = '/api';

export default {
  data() {
    return {
      file: null,
      message: ''
    }
  },
  methods: {
    onFileChange(event) {
      this.file = event.target.files[0];
    },
    async uploadFile() {
      if (!this.file) {
        this.message = "Selecione um arquivo CSV!";
        return;
      }
      const formData = new FormData();
      formData.append('file', this.file);
      try {
        const response = await axios.post(url+'/importar-produtos-csv', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        this.message = response.data.message;
      } catch (error) {
        console.error(error);
        this.message = error.response ? error.response.data.error : "Erro ao enviar o arquivo CSV";
      }
    }
  }
};
</script>

<style scoped>
</style>
